import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
  Input,
  Button,
  NotificationBanner,
  ErrorSummary,
} from 'govuk-react-jsx';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAccountEmail,
  getVerificationCode,
  setVerificationCode,
  getEmailCodeResent,
  setEmailCodeResent,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkEmail, resendCode } from '../../firebase';
import { checkValidEmailCode } from '../../regex/regex';
import useTitle from '../../hooks/useTitle';

const CheckEmail = () => {
  const [success, setSuccess] = useState(false);
  const [errMessage, setErrMessage] = useState(null);
  const [errorList, setErrorList] = useState([]);

  const verificationCodeRedux = useSelector(getVerificationCode);
  const accountEmailRedux = useSelector(getAccountEmail);

  // emailCodeResentRedux is true if user clicks on 'Request a new code' button on IncorrectVerificationCode screen
  const emailCodeResentRedux = useSelector(getEmailCodeResent);
  const dispatch = useDispatch();
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'landlordReg.CheckEmail.s13',
    'Enter the code to confirm your email address - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const errorMessage = copyProvider.getCopy(
    'landlordReg.CheckEmail.s12',
    'The verification code must be 6 characters in length and only uppercase letters.'
  );

  const updatedVerificationCode = (event) => {
    dispatch(setVerificationCode(event.target.value));
  };

  const handleBtnClick = () => {
    if (checkValidEmailCode.test(verificationCodeRedux)) {
      setErrMessage(null);
      checkEmail({ emailOtp: verificationCodeRedux })
        .then(() => {
          history.push('/landlordReg/email-verified');
        })
        .catch(() => {
          // checkEmail does not return a value to check success, it just returns in catch()
          history.push('/landlordReg/incorrect-verification-code');
        });
      dispatch(setVerificationCode(''));
    } else {
      setErrMessage({
        children: errorMessage,
      });
      setErrorList([
        { children: errorMessage, href: '#input-with-error-message' },
      ]);
    }
  };

  const resendEmail = () => {
    //  reset flag from IncorrectVerificationCode
    dispatch(setEmailCodeResent(false));
    setSuccess(false);

    resendCode({ type: 'email' })
      .then(() => {
        setSuccess(true);
      })
      .catch(() => {
        // TODO: Show network error message
        setSuccess(false);
      });
  };

  const title = copyProvider.getCopy(
    'landlordReg.CheckEmail.s9',
    'Email code has been sent again'
  );

  const hint = copyProvider.getCopy(
    'landlordReg.CheckEmail.s5',
    'For example, DNCLRK'
  );

  const label = copyProvider.getCopy(
    'landlordReg.CheckEmail.s6',
    'Verification code'
  );

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      {(success || emailCodeResentRedux) && (
        <NotificationBanner type="success" titleChildren={title}>
          <p className="govuk-body">
            {copyProvider.getCopy(
              'landlordReg.CheckEmail.s10',
              'We have sent you a new verification code via email, this may take a few minutes to arrive.'
            )}
          </p>
        </NotificationBanner>
      )}
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.CheckEmail.s2',
          'Enter the code to confirm your email address'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.CheckEmail.s3',
          'We have sent a verification code to: '
        )}
        {accountEmailRedux ? <b>{`${accountEmailRedux}. `}</b> : '"X". '}
        {copyProvider.getCopy(
          'landlordReg.CheckEmail.s11',
          'It may take a few minutes to arrive. If the email does not arrive, check your junk or spam folder.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.CheckEmail.s4',
          'If you use a browser to access your email, you may need to open a new window or tab to see the code.'
        )}
      </p>

      <div className="govuk-form-group">
        <Input
          errorMessage={errMessage}
          id="input-with-error-message"
          className="govuk-input--width-10"
          hint={{
            children: hint,
          }}
          label={{
            children: label,
          }}
          name="test-width-10"
          type="text"
          value={verificationCodeRedux}
          onChange={(event) => updatedVerificationCode(event)}
        />
      </div>
      <p>
        <Link
          className="govuk-body"
          onClick={() => resendEmail()}
          to="/landlordReg/check-email"
        >
          {copyProvider.getCopy(
            'landlordReg.CheckEmail.s7',
            'I have not received an email'
          )}
        </Link>
      </p>

      <br />

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('landlordReg.CheckEmail.s8', 'Continue')}
      </Button>
    </>
  );

  return pageModel;
};

export default CheckEmail;
